export const Modes = {
	Staging: 'staging',
	Production: 'production',
};
